import React,{ useState,useEffect } from 'react';
import axios from 'axios';
import { unescapeHtml } from "../../../components/common/Common";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

//팝업창 - 약관 보여주기
const PopupConditions = ({varPopupConditionWin,onCloseConditionHandler,varConditionItem}) => {
  const [varConditionTitle,setConditionTitle] = useState('');
  const [varConditionComment,setConditionComment] = useState('');

  //약관호출
  const GetConditionInformation = async(sfield) => {
    const sendData = {sfield:sfield};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_conditions`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setConditionComment(unescapeHtml(datas.comments));
      } else {
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    if(varPopupConditionWin) {
      let stitle = "";
      let sfield = "";
      switch (varConditionItem) {
        default:
        case 1:
          stitle = "이용약관 동의";
          sfield = "env_condition";
          break;
        case 2:
          stitle = "개인정보 처리방침 동의";
          sfield = "env_privacy";
          break;
        case 3:
          stitle = "환불 취소 정책 동의";
          sfield = "env_refund";
          break;
        case 4:
          stitle = "마케팅 목적의 개인정보 수집 및 이용동의";
          sfield = "env_marketing";
          break;
      }
      setConditionTitle(stitle)
      GetConditionInformation(sfield);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPopupConditionWin]);

  return (
    <>
      <div className={varPopupConditionWin?"layer-bg open":"layer-bg"}></div>
      <div className={varPopupConditionWin?"layer-pop open":"layer-pop"} style={{width:"95%",height:"90vh"}}>
        <div className="layer_inner">
          <div className="layer-hd">
            <div className="tit">{varConditionTitle}</div>
            <div className="close-layer" onClick={e=>onCloseConditionHandler(e)}><img src={cancelIcon} alt=""/></div>
          </div>
          <div className="center_wrap" style={{padding:"50px 0px 0px 0px"}}>
            <div className="scroll-wrap">{varConditionComment}</div>
          </div>
        </div>
      </div>
    </>
  )
}
export default PopupConditions;